'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AccessibleTextField = require('./components/AccessibleTextField.component');

var _AccessibleTextField2 = _interopRequireDefault(_AccessibleTextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AccessibleTextField2.default; /*
                                                  * Exports
                                                  */


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/accessibility/text-field/lib/index.js
// module id = 259
// module chunks = 0 1 4